import { useGetRefValue } from '@/features/equipment-browser/subscriptions/use-get-ref-value';

import { useCompressorAlarmRefs } from './use-compressor-alarm-refs';
import type { CompressorAlarm } from '../compressor-alarm-code.types';
import { decodeCompressorAlarmCode } from '../compressor-alarm-code.utils';

/**
 * The compressor's live, decoded `AlarmCode` while its `DecodeAlarmCode` condition is
 * true; nothing otherwise, or for a device without alarm code points.
 *
 * Only reads the points: pages stream them through `useCompressorAlarmSubscriptionIds`.
 */
export const useCompressorAlarm = (deviceId: string): CompressorAlarm | undefined => {
  const refs = useCompressorAlarmRefs(deviceId);

  const code = useGetRefValue(refs?.alarmCode);
  const compressorType = useGetRefValue(refs?.compressorType);
  const decodeAlarmCode = useGetRefValue(refs?.decodeAlarmCode);

  if (decodeAlarmCode !== true) return undefined;
  return decodeCompressorAlarmCode(
    typeof code === 'number' ? code : undefined,
    typeof compressorType === 'string' ? compressorType : undefined
  );
};
